import { Amplify } from 'aws-amplify';

// Runtime Amplify/Cognito configuration. Unlike a build-time setup, the app
// client id is per tenant (one Cognito app client per root organization) and
// only known once the tenant config is loaded — so TenantBootstrap calls
// configureAmplify() with the runtime client id before rendering the app.
// Pool id and hosted-login domain are pool-level (shared by every tenant of
// an environment) and stay env vars.

const domainUrl = () => process.env.REACT_APP_COGNITO_DOMAIN || '';

let configuredClientId = null;

export const configureAmplify = (clientId) => {
    if (!clientId || clientId === configuredClientId) return;

    // Amplify expects the bare domain, without protocol
    const domain = domainUrl().replace(/^https?:\/\//, '');

    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
                userPoolClientId: clientId,
                loginWith: {
                    oauth: {
                        domain,
                        scopes: ['openid', 'email', 'profile'],
                        redirectSignIn: [`${window.location.origin}/redirect`],
                        redirectSignOut: [`${window.location.origin}/init-login`],
                        responseType: 'code',
                    },
                },
            },
        },
    });
    configuredClientId = clientId;
};
